import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { FeatureUtil, Feature } from 'utils/FeatureUtil';

export const useFeature = (feature: Feature): boolean => {
  const user = useSelector((state: RootState) => state.user.user);
  return FeatureUtil.isEnabled(feature, user?.roles);
};
